import HttpError from 'shared/classes/HttpError';
import { IHttp } from 'shared/interfaces/IHttp';
import { ContentTypes } from 'shared/enums/ContentTypes';
import { env } from 'env';

const baseURL = env.REACT_APP_CORE_API_URI || '';

const forcedQaLane = localStorage.getItem('forcedQaLane')
  ? JSON.parse(localStorage.getItem('forcedQaLane') || '')
  : null;

const qaRegex = /qa\d{1,3}/gm;

export const defaultQaLane = baseURL.match(qaRegex)?.[0];

export const getEnvironment = (): string => {
  if (baseURL.includes('production') || baseURL.includes('owl')) {
    return 'prod';
  } else if (baseURL.includes('demo')) {
    return 'demo';
  } else {
    return defaultQaLane || '';
  }
};

export const getQaCoreApiUrl = (subscription: boolean): string => {
  const coreApiUrl = subscription ? env.REACT_APP_SUBSCRIPTIONS_URI : env.REACT_APP_CORE_API_URI;
  if (!forcedQaLane || getEnvironment() === 'prod') {
    return coreApiUrl || '';
  }
  const protocol = subscription ? 'wss' : 'https';
  return `${protocol}://core-api.${forcedQaLane}.dev.otto.vet`;
};

export const coreApiUrl = getQaCoreApiUrl(false);

const http = async <TResponse>({
  method,
  url,
  token,
  body,
  clinicUser,
  contentType = ContentTypes.Json,
}: IHttp): Promise<TResponse> => {
  const headers: Record<string, string> = {
    authorization: token ? `Bearer ${token}` : '',
    clinic: clinicUser?.vetInfo?.currentClinic?.id || '',
    'fetch-client': 'generic-fetch',
  };

  if (contentType !== ContentTypes.MultiPartFormData) {
    headers['content-type'] = contentType;
  }

  const response = await fetch(url, {
    method,
    headers,
    body: body || null,
  });

  if (!response.ok) {
    throw new HttpError(response.status, response.statusText);
  }

  const data = await response.json();

  return data as TResponse;
};

export default http;
